<template>
  <aha-modal
    :no-margin-padding="true"
    :visible-overflow="true"
    :hideHeader="true"
    width="405px"
    @hide="$emit('hide')"
    v-if="isOpenModal"
  >
    <div class="p-6 relative pricing-container-v3 modal-bulk">
      <div class="flex flex-row justify-end align-middle pb-1.5 modal-close">
        <aha-icon
          name="close"
          @click="$emit('hide')"
          width="16"
          height="16"
          viewBox="0 0 24 24"
        />
      </div>
      <div class="title-speak-to-us">
        {{ isSelectWhiteLabelAndEnterprise ? $i18nPresenter.t('Request a quote') : $i18nPresenter.t('Contact us') }}
      </div>
      <div>
        <div class="summary mt-5 font-bold mb-2 font-16">
          {{ $i18nPresenter.t('Summary') }}:
        </div>
        <div class="wrapper-info-plan">
          <div class="font-bold font-18">
            {{ plans[plan] }}
          </div>
          <div class="flex justify-between mt-2">
            <div>
              {{ $i18nPresenter.t('Billing cycle') }}
            </div>
            <div>
              {{ $i18nPresenter.t('Yearly') }}
            </div>
          </div>
          <div class="flex justify-between mt-2">
            <div>
              {{ $i18nPresenter.t('Quantity') }}
            </div>
            <div>
              x {{ quantity }} {{ $i18nPresenter.t('licences') }}
            </div>
          </div>
          <div>
            <div class="pt-4" v-if="!isSelectWhiteLabelAndEnterprise">
              <div class="pb-4  border-t border-base-30"></div>
              <div class="flex justify-between items-center ">
                <div class="flex items-center">
                  <span class="font-14 font-bold">
                    {{ $i18nPresenter.t('Total') }}
                  </span>
                  <span class="pricing-label-discount ml-2 small-label font-12" v-if="discountRate !==0 ">
                    <p>{{ $i18nPresenter.t('Save') }} {{ Math.round(discountRate * 100) }}%</p>
                  </span>
                </div>
                <div>
                  <del class="ml-1 total-billing  font-12 " v-if="discountRate !== 0">
                    {{ symbolCurrency }}{{ Math.round(totalBilling * 100) / 100 | formatNumber }}
                  </del>
                  <span :class="{'currency-grid-area': totalBillingHaveDiscount > 0}">
                    <span class="font-bold ml-1 font-14" v-if="totalBillingHaveDiscount > 0">
                      {{ symbolCurrency }}{{ Math.round(totalBillingHaveDiscount * 100) / 100 | formatNumber }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <form @submit.prevent="onSubmitForm">
          <div class="mt-5">
            <div class="font-bold mb-2">
              {{ $i18nPresenter.t('Email') }}:
            </div>
            <aha-input
              type="email"
              required
              @focus="trackingFocus('email')"
              v-model="localFormData.email"
              :placeholder="$i18nPresenter.t('Enter your email')"
            />
          </div>
          <div class="mt-5">
            <div class="font-bold mb-2">
              {{ $i18nPresenter.t('Message') }}:
            </div>
            <aha-textarea
              @focus="trackingFocus('requirement')"
              v-model="localFormData.message"
              class="text-area"
              :placeholder="$i18nPresenter.t('Enter your message')"
              :max-length="1000"
            />
          </div>
          <aha-button type="submit" class="w-full mt-4 submit-request" :disabled="submitting">
            {{ isSelectWhiteLabelAndEnterprise ? $i18nPresenter.t('Request') : $i18nPresenter.t('Submit') }}
            <aha-spinner class="ml-1" v-if="submitting" variant="white" />
          </aha-button>
          <div class="mt-3 text-center">
            {{ $i18nPresenter.t('We will contact you shortly') }}.
          </div>
        </form>
      </div>
    </div>
  </aha-modal>
</template>
<script >
import { mapActions } from 'vuex'
import Util from '@/util'
import PaymentLocalizationMixin from '@/components-v2/my-plan/user-pricing-v2/PaymentLocalizationMixin'

export default {
  mixins: [PaymentLocalizationMixin],
  props: {
    totalBillingHaveDiscount: {
      type: Number,
      default: 0,
    },
    plan: {
      type: String,
      default: '',
    },
    quantity: {
      type: [String, Number],
      default: 0,
    },
    isOpenModal: {
      type: Boolean,
      default: false,
    },
    discountRate: {
      type: Number,
      default: 0,
    },
    totalBilling: {
      type: Number,
      default: 0,
    },
    plans: {
      type: Object,
      default: () => ({

      }),
    },
    formData: {
      type: Object,
      default: () => ({
        email: '',
        message: '',
      }),
    },

  },
  data() {
    return {
      localFormData: { ...this.formData },
      submitting: false,
    }
  },
  computed: {
    isSelectWhiteLabelAndEnterprise() {
      return this.plan === 'enterprise' || this.plan === 'whitelabel'
    },
  },
  watch: {
    formData: {
      handler(newValue) {
        this.localFormData = { ...newValue }
      },
      deep: true,
    },
    localFormData: {
      handler(newValue) {
        this.$emit('update:formData', newValue)
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['createCheckoutSessionAction', 'hookBulkPricingAction']),
    onSubmitForm() {
      this.submitting = true

      this.createHookBulkPricing()
    },

    async createHookBulkPricing() {
      const payload = {
        planType: this.plan,
        numOfLicenses: this.quantity,
        email: this.formData.email,
        requirement: this.formData.message,
        currency: this.fullSymbolCurrency,
      }
      const res = await this.hookBulkPricingAction(payload)
      Util.mixpanelTracking('My Plan', 'BLP > Request a quote > Submit form', this.plan, null, {
        quantity: this.quantity,
        amount: Math.round(this.totalBillingHaveDiscount * 100) / 100,
      })
      if (res) {
        this.$emit('showThanksModal')
        this.submitting = false
      }
    },
    trackingFocus(type) {
      const eventCustoms = {
        quantity: this.quantity,
        amount: Math.round(this.totalBillingHaveDiscount * 100) / 100,
      }
      if (type === 'email') {
        Util.mixpanelTracking('My Plan',
          'BLP > Request a quote > Email > Focus input', this.plan, null,
          eventCustoms)
        return
      }
      if (type === 'requirement') {
        Util.mixpanelTracking('My Plan',
          'BLP > Request a quote > Message > Focus input', null,
          this.plan,
          eventCustoms)
        return
      }
      if (type === 'quantity') {
        Util.mixpanelTracking('My Plan',
          'BLP > Quantity > Focus input', null,
          this.plan,
          eventCustoms)
      }
    },

  },
}
</script>

<style lang="scss" scoped>
.modal-bulk {
  padding-top: 50px !important;
}

.modal-close {
  right: 16px !important;
  top: 16px !important;
}
</style>
